import { render, staticRenderFns } from "./businessTransaction.vue?vue&type=template&id=27cf94ad&scoped=true&"
import script from "./businessTransaction.vue?vue&type=script&lang=js&"
export * from "./businessTransaction.vue?vue&type=script&lang=js&"
import style0 from "./businessTransaction.vue?vue&type=style&index=0&id=27cf94ad&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cf94ad",
  null
  
)

export default component.exports